<template>
  <div class="wrapper-container">
    <el-container class="main-page">
      <header-top :menu.sync="menu"></header-top>
      <side-bar :active="menu"></side-bar>
      <el-main @click.native="menu = chatbot = false">
        <div class="main-content">
          <router-view></router-view>
        </div>
      </el-main>
      <chat-bot-page :active.sync="chatbot"
        v-if="chatbotVisible"
        :skill="$route.params.skill"></chat-bot-page>
    </el-container>
  </div>
</template>

<script>
import $ from 'jquery'

// $(function (){
//   $('head').append($('<script>').attr({type: 'text/javascript', href: '/DragDropTouch.js'}))
// })
// import State from '../stores/state.js'

import HeaderTop from './HeaderTop.vue'
import SideBar from './SideBar.vue'
import ChatBotPage from '../components/pages/ChatBotPage.vue'
window.$ = $

export default {
  name: 'Main',
  components: {
    HeaderTop,
    SideBar,
    ChatBotPage,
  },
  data () {
    return {
      menu: false,
      chatbot: false,
    }
  },
  computed: {
    chatbotVisible () {
      let skill = this.$route.params.skill
      return !!skill && skill !== 'global'
    },
  },
  created () { this.checkChatbotHash() },
  watch: {
    menu (value) { if (value) this.chatbot = false },
    chatbot (value) {
      if (value) {
        this.menu = false
        if (this.$route.hash !== '#chatbot') {
          this.$router.replace({ query: this.$route.query, hash: '#chatbot' })
        }
      } else if (this.$route.hash === '#chatbot') {
        this.$router.replace({ query: this.$route.query, hash: null })
      }
    },
    chatbotVisible () { this.chatbot = false },
    '$route' () { this.menu = false },
    '$route.hash' () { this.checkChatbotHash() },
  },
  provide () {
    return {
      onerror: (...data) => this.onerror(...data),
    }
  },
  methods: {
    checkChatbotHash () {
      this.chatbot = this.$route.hash === '#chatbot'
    },
    onerror (error, prefix) {
      console.error(error)
      if (error.status === 401) return
      prefix = prefix || 'Error'
      let message = error.responseJSON
        ? error.responseJSON.errors.join(', ') : error
      this.$message({
        message: prefix + ': ' + message,
        type: 'error',
      })
    },
  },
}
</script>

<style lang="scss">
  @import "../element-variables.scss";
  // Set default font and color
  body {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $--color-text-primary;
    margin: 0;
  }
  // Contains teh main content, and deals with its scroll
  .main-page > .el-main {
    height: 100vh;
    overflow-y: scroll;
    padding: 0;
    flex-grow: 1;
    flex-shrink: 1;
  }

  .main-content {
    max-width: 700px;
    margin: 20px;
    margin-right: 50px;
  }

  // can group any input in <el-button-group>
  .el-button-group {
    display: flex !important;
    height: 40px;

    // flex size of inputs and <el-form-small-item>
    > .el-input,
    > .el-autocomplete,
    > .el-input-number,
    > .el-select,
    > .el-form-small-item.is-flex {
      flex: $field-flex;
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        height: 0;
      }
      &:hover {
        scrollbar-width: thin;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        &::-webkit-scrollbar {
          height: 6px;
        }
        &::-webkit-scrollbar-track {
          background: $--background-color-base;
        }
        &::-webkit-scrollbar-thumb {
          background: $--border-color-hover;
        }
      }
    }
    // any input inside <el-form-small-item> should take full width
    > .el-form-small-item.is-flex {
      > .el-input,
      > .el-autocomplete,
      > .el-input-number,
      > .el-select {
        width: 100%;
      }
    }
    // straight left border except for the first child
    // to separate the fields and buttons
    > .el-input:not(:first-child) .el-input__inner,
    > .el-autocomplete:not(:first-child) .el-input__inner,
    > .el-input-number:not(:first-child) .el-input__inner,
    > .el-input:not(:first-child) .el-input-group__prepend,
    > .el-select:not(:first-child) .el-input__inner,
    > .el-readio.is-bordered:not(:first-child),
    > .el-checkbox.is-bordered:not(:first-child),
    > .el-button:not(:first-child),
    > .el-form-small-item:not(:first-child) .el-input__inner,
    > .el-form-small-item:not(:first-child) .el-input-group__prepend,
    > .orderable-box--title:not(:first-child) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    // clear margin-left from default CSS
    > .el-input:not(:first-child),
    > .el-autocomplete:not(:first-child),
    > .el-input-number:not(:first-child),
    > .el-input:not(:first-child),
    > .el-select:not(:first-child),
    > .el-button:not(:first-child),
    > .el-radio.is-bordered:not(:first-child),
    > .el-checkbox.is-bordered:not(:first-child),
    > .el-form-small-item:not(:first-child),
    > .orderable-box--title:not(:first-child) {
      margin-left: 0 !important;
    }
    // clear margin-right from default CSS
    > .el-input:not(:last-child),
    > .el-autocomplete:not(:last-child),
    > .el-input-number:not(:last-child),
    > .el-input:not(:last-child),
    > .el-select:not(:last-child),
    > .el-button:not(:last-child),
    > .el-radio.is-bordered:not(:last-child),
    > .el-checkbox.is-bordered:not(:last-child),
    > .el-form-small-item:not(:last-child),
    > .orderable-box--title:not(:last-child) {
      margin-right: 0 !important;
    }
    // remove right border except for the last child
    > .el-input:not(:last-child) .el-input__inner,
    > .el-autocomplete:not(:last-child) .el-input__inner,
    > .el-input-number:not(:last-child) .el-input__inner,
    > .el-input:not(:last-child) .el-input-group__append,
    > .el-select:not(:last-child) .el-input__inner,
    > .el-button:not(:last-child),
    > .el-radio.is-bordered:not(:last-child),
    > .el-checkbox.is-bordered:not(:last-child),
    > .el-form-small-item:not(:last-child) .el-input__inner,
    > .el-form-small-item:not(:last-child) .el-input-group__prepend,
    > .orderable-box--title:not(:last-child) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right-width: 0px !important;
    }
    // left border is red if the previous element is red
    // in order ot have both borders red
    > .is-error + *, .is-error + .el-form-item.is-success {
      &.el-input .el-input__inner,
      &.el-autocomplete .el-input__inner,
      &.el-input-number .el-input__inner,
      &.el-input .el-input-group__prepend,
      &.el-select .el-input__inner,
      &.el-radio.is-bordered,
      &.el-checkbox.is-bordered,
      &.el-button,
      &.el-form-small-item .el-input__inner,
      &.el-form-small-item .el-input-group__prepend,
      &.orderable-box--title {
        border-left-color: $--color-danger !important;
      }
    }
  }
  // left border is red if the previous element is red
  // (global <el-form-item> case)
  .el-form-item.is-error > .el-button-group {
    > .el-input,
    > .el-autocomplete,
    > .el-input-number,
    > .el-select {
      + .el-button,
      + .el-radio.is-bordered,
      + .el-checkbox.is-bordered, {
        border-left-color: $--color-danger !important;
      }
    }
  }
  // Gey background for disabled default button
  .el-button.el-button--default.is-disabled {
    border-color: $--border-color-base;
    /*color: $--color-text-regular;*/
    background-color: $--background-color-base;
    cursor: default !important;
  }
  .el-button {
    text-decoration: none;
  }
  // Info buttons are grey
  .el-button.el-button--info,
  .el-button.el-button--info.is-disabled,
  .el-button-group .el-button.el-button--info,
  .el-button-group .el-button.el-button--info.is-disabled {
    background-color: $--background-color-base;
    color: $--color-text-secondary;
    border: 1px solid $--border-color-base;
    border-right-color: $--border-color-base;
    border-left-color: $--border-color-base;
  }
  // Yet another weird default element CSS rule to override
  body .el-button-group .el-button--info:not(:first-child):not(:last-child) {
    border-left-color: $--border-color-base;
    border-right-color: $--border-color-base;
  }
  // Success inputs are normal,
  // a button is in error only if the closest el-form-item is in error
  .el-form-item.is-error .el-form-item:not(.is-error),
  .el-form-item.is-success {
    .el-input__inner, .el-textarea__inner {
      border-color: $--border-color-base !important;
      // be careful to keep the right color when focused
      &:focus, &:focus-within, &:hover, &:focus-within:hover {
        border-color: $--border-color-hover !important;
      }
    }
  }
  // Get rid of the browser's ugly blue color for focused inputs
  body {
    .el-input__inner, .el-textarea__inner,
    .el-checkbox.is-bordered, .el-radio.is-bordered,
    .el-checkbox__input .el-checkbox__inner,
    .el-checkbox__input.is-focus .el-checkbox__inner,
    .el-radio__input .el-radio__inner,
    .el-radio__input.is-focus .el-radio__inner {
      &:focus, &:focus-within, &:hover, &:focus-within:hover {
        border-color: $--border-color-hover;
      }
    }
    .el-checkbox__input.is-focus .el-checkbox__inner,
    .el-radio__input.is-focus .el-radio__inner {
      border-color: $--border-color-base;
    }
  }
  // But keep it red when in error
  body .el-form-item.is-error.is-error {
    .el-input__inner, .el-textarea__inner {
      &:focus, &:focus-within, &:hover, &:focus-within:hover {
        border-color: $--color-danger;
      }
    }
  }
  // Disabled stuffs have the same border as normal
  .is-disabled {
    .el-input__inner, .el-textarea__inner,
    .el-input-number__decrease, .el-input-number__increase,
    &.el-checkbox.is-bordered, &.el-radio.is-bordered {
      border-color: $--border-color-base !important;
    }
  }
  // center more the text of bordered checkboxes in <el-button-group>
  .el-button-group .el-checkbox.is-bordered {
    padding-left: 6px;
    padding-right: 6px;
  }
  // reduce the default with of incr-decr button in <el-button-group>
  .el-button-group .el-input-number__increase,
  .el-button-group .el-input-number__decrease {
    width: 25px;
  }
  // remove the ugly blue border of checked boxes in <el-button-group>
  .el-button-group .el-checkbox.is-bordered.is-checked,
  .el-button-group .el-radio.is-bordered.is-checked {
    border-color: $--border-color-base;
  }
  // Building a big checkbox type that takes the whole width of <el-button-group>
  .el-checkbox.el-checkbox--big.is-bordered {
    /*padding: 6px 20px 6px 10px;*/
    padding: 6px;
  }
  .el-checkbox.el-checkbox--big .el-checkbox__inner {
    width: 2 * $--checkbox-input-width;
    height: 2 * $--checkbox-input-height;
  }
  .el-checkbox.el-checkbox--big .el-checkbox__inner::after {
    border-width: 2px;
    height: 14px;
    width: 6px;
    left: 8px;
    top: 2px;
  }
  // Lighter fieldset border
  fieldset {
    border: 1px solid $--border-color-base;
    border-radius: 4px;
    margin: 5px 0 10px;
    > legend {
      color: $--color-info;
      font-weight: bold;
    }
  }
  // remove the margin of <el-form-small-item> in <el-form-item>
  body .el-form-item .el-form-item {
    margin-bottom: 22px;
    &.el-form-small-item {
      margin-bottom: 0;
    }
  }
  // fix the size and color of tooltip icons
  i.el-tooltip {
    font-size: $--font-size-base;
  }
  i.el-tooltip.el-icon-info {
    color: $--color-info;
  }
  i.el-tooltip.el-icon-success {
    color: $--color-success;
  }
  i.el-tooltip.el-icon-warning {
    color: $--color-warning;
  }
  i.el-tooltip.el-icon-danger {
    color: $--color-danger;
  }
  // display tooltip icons at the end in <el-option> and <el-dropdown-item>
  .el-dropdown-menu__item .el-dropdown-menu__tooltip {
    display: inline-block;
    line-height: 34px;
    float: right;
    margin-left: 10px;
  }
  .el-dropdown-menu__item > i.el-tooltip {
    display: inline-block;
    line-height: 36px;
    float: right;
    margin-left: 10px;
  }
  // make tooltip smoother color
  body .el-tooltip__popper.is-light {
    color: $--color-info;
    border-color: $--color-info;
  }
  // class for giving color to text
  .info-text {
    color: $--color-info;
  }
  .success-text {
    color: $--color-success;
  }
  .warning-text {
    color: $--color-warning;
  }
  .danger-text {
    color: $--color-danger;
  }
  // slightly darker separation in <el-dropdown>
  .el-dropdown .el-button.el-dropdown__caret-button::before {
    background-color: $--border-color-base !important;
  }
  // A grey background begind <el-breadcrumb>
  .el-breadcrumb {
    padding: 10px;
    background: #f7f7f7;
    border-radius: $--border-radius-base;
  }
  // background color was missing for primary dark alert
  .el-alert--primary.is-dark {
    background-color: $--color-primary;
  }
  // use the nornal color for links in alerts
  .el-alert a {
    color: inherit;
  }
  // reset line-height for alert in <el-form-item>
  .el-form-item__content .el-alert {
    line-height: 18px;
  }
  // the background color for new inputs when comparing
  .comparable-new .el-input__inner,
  .comparable-new .el-textarea__inner,
  .comparable-new.orderable-box .orderable-box--title {
    background-color: $--color-primary-lighter;
  }
  // the background color for old inputs when comparing
  .comparable-old .el-input.is-disabled .el-input__inner,
  .comparable-old .el-textarea.is-disabled .el-textarea__inner,
  .comparable-old.orderable-box .orderable-box--title,
  .comparable-old.el-checkbox,
  .comparable-old.el-radio {
    background-color: $--color-warning-lighter;
  }
  // the background color for different inputs when comparing
  .comparable-diff .el-form-item__content,
  .comparable-diff.el-checkbox,
  .comparable-new.el-checkbox,
  .comparable-diff.el-radio,
  .comparable-new.el-radio {
    background-color: $--color-primary-lighter;
  }
  // temporary blue background color when scrolling to anchor
  .anchor-not-selected {
    -webkit-transition: background-color 500ms linear;
    -moz-transition: background-color 500ms linear;
    -o-transition: background-color 500ms linear;
    -ms-transition: background-color 500ms linear;
    transition: background-color 500ms linear;
  }
  .anchor-selected {
    background-color: $--color-primary-lighter;
  }
  // add blue outline when focusing inputs in a <button-group>
  .el-button-group > *,
  .el-form-item__content > * {
    &.el-form-small-item,
    &.el-checkbox.is-bordered,
    &.el-input, &.el-input, &.el-textarea,
    &.el-autocomplete, &.el-select {
      &:focus-within {
        outline: auto $--color-primary;
      }
    }
  }
  // and for normal inputs
  .el-form-item__content > *,
  .el-form-small-item > * {
    &.el-textarea:focus-within {
      outline: auto $--color-primary;
    }
  }
  // and a shadow for checkboxes
  .el-checkbox:not(.is-bordered) .el-checkbox__input.is-focus .el-checkbox__inner {
    // outline: auto $--color-primary;
    box-shadow: 0 0 2px 2px $--color-primary;
  }

  .el-form-item__content > .el-input {
    display: block;
  }

  fieldset > *, .fieldset-container > * {
    &.el-form-item:last-child, &.comparator:last-child > .comparator-vue > .el-form-item {
      margin-bottom: 0;
    }
  }

  .fieldset-container.el-form-item {
    margin-bottom: 0;
  }
</style>
